import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './LocationSelector.scss';
import Icon from '../../Common/Icon';
import { NavLink } from 'react-router-dom';

const LocationSelector = ({ onChangeLocation, selectedLocation }) => {
    const validLocation = selectedLocation && selectedLocation.name;

    return (
        <Fragment>
            {validLocation ? (
                <div className="row align-items-center location-selector">
                    <div
                        className="col-sm-11 col-md-8 col-lg-5 alert alert-light d-flex justify-content-between align-items-center"
                        onClick={onChangeLocation}
                    >
                        <span>
                            {selectedLocation.name} ({selectedLocation.abbreviation})
                        </span>
                        <Icon name="caret-down" />
                    </div>
                    <div className="col-sm-1 offset-md-3 offset-lg-6 text-end">
                        <NavLink className="print text-decoration-none" to="/reports/18">
                            <Icon name="print" /> Print
                        </NavLink>
                    </div>
                </div>
            ) : (
                <div className="alert alert-danger">
                    Your account does not have access to any active locations. Please submit a Support Ticket to your subscription
                    administrator(s) to resolve this issue.
                </div>
            )}
        </Fragment>
    );
};

LocationSelector.propTypes = {
    onChangeLocation: PropTypes.func.isRequired,
    selectedLocation: PropTypes.object.isRequired,
};

export default LocationSelector;
